import { render, staticRenderFns } from "./Switchsite.vue?vue&type=template&id=32f57a88&scoped=true&"
import script from "./Switchsite.vue?vue&type=script&lang=js&"
export * from "./Switchsite.vue?vue&type=script&lang=js&"
import style0 from "./Switchsite.vue?vue&type=style&index=0&id=32f57a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f57a88",
  null
  
)

export default component.exports